import { useState, Dispatch, useRef } from 'react'

export default function useDebouncedState<T>(value: T, delay: number): [T, Dispatch<T>] {
  const [debouncedValue, setDebouncedValue] = useState(value)
  const handler = useRef<any>(null)

  const setValue = (value: T) => {
    if (handler.current) clearTimeout(handler.current)

    handler.current = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)
  }

  return [debouncedValue, setValue]
}
